//In production store these in environment variables
// export const BASE_URL = "http://localhost:5000/api";
// export const IMG_URL = "http://localhost:5000/";

export const BASE_URL = "https://kcmit-api.kcmit.edu.np/api";
export const IMG_URL = "https://kcmit-api.kcmit.edu.np/";

// export const BASE_URL = "https://dev-api.kcmit.edu.np/api";
// export const IMG_URL = "https://dev-api.kcmit.edu.np/";
